// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".topHeader-container {\n  display: flex;\n  padding: 15px;\n  justify-content: space-between;\n}\n\n.topHeader-iconAndInfo {\n  display: flex;\n  flex-grow: 1;\n}\n\n.topHeader-logo {\n  margin-right: 10px;\n}\n\n.topHeader-helpButtonIcon {\n  padding: 0 10px;\n}\n", ""]);
// Exports
module.exports = exports;
